import ColorModeSwitchContainer from './ColorModeSwitcher.container';
export default ColorModeSwitchContainer;